/**
 * Ð£ÑÐ»Ð¾Ð²Ð¸Ñ Ð±Ð°Ð½ÐºÐ¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¸Ð·Ð²ÐµÑÑÐ½Ñ Ð·Ð°ÑÐ°Ð½ÐµÐµ Ð¸ Ð¿ÑÐ¾Ð²ÐµÑÑÑÑÑÑ Ð´Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð·Ð°ÑÐ²ÐºÐ¸.
 *
 * ÐÐ°ÑÐµÐ¼: Ð·Ð° Ð½ÐµÐ´ÐµÐ»Ñ Freedom Ð¾ÑÐºÐ°Ð·Ð°Ð» 305 Ð·Ð°ÑÐ²ÐºÐ°Ð¼ Ð¸Ð· 937 Ð¿Ð¾ Ð²Ð·Ð½Ð¾ÑÑ Ð¸ ÑÑÐ¾ÐºÑ â
 * Ð±Ð¾Ð»ÑÑÐµ, ÑÐµÐ¼ Ð¾Ð´Ð¾Ð±ÑÐ¸Ð» (65). ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ·Ð½Ð°ÑÑ Ð¾Ð± ÑÑÐ¾Ð¼ ÑÐµÑÐµÐ· Ð¿Ð¾Ð»ÑÐ°ÑÐ° Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸,
 * ÑÐ¾ÑÑ ÑÑÐ»Ð¾Ð²Ð¸Ðµ Ð¸Ð·Ð²ÐµÑÑÐ½Ð¾ Ð² Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð²Ð²Ð¾Ð´Ð°. ÐÐ° ÑÑÐ¾ÐºÐ°Ñ 36, 48 Ð¸ 24 Ð¾ÑÐºÐ°Ð· Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ
 * Ð¿Ð¾ÑÑÐ¸ Ð²ÑÐµÐ³Ð´Ð° (45 Ð¸Ð· 48, 37 Ð¸Ð· 40, 19 Ð¸Ð· 23), Ð½Ð° 60/72/84 Ð¾ÑÐºÐ°Ð·Ð¾Ð² Ð¿Ð¾ ÑÑÐ¾ÐºÑ Ð½ÐµÑ.
 *
 * Ð­ÑÐ¾ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ°, Ð° Ð½Ðµ Ð·Ð°Ð¿ÑÐµÑ: ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð±Ð°Ð½ÐºÐ¾Ð² Ð¼ÐµÐ½ÑÑÑÑÑ, Ð±ÑÐ²Ð°ÑÑ Ð°ÐºÑÐ¸Ð¸ Ð¸ ÑÑÑÐ½ÑÐµ
 * Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑÐ½Ð½Ð¾ÑÑÐ¸. ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð¸Ð´Ð¸Ñ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð¸ ÑÐµÑÐ°ÐµÑ ÑÐ°Ð¼.
 *
 * ÐÐ¾ÐºÐ° Ð·Ð´ÐµÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Freedom â ÑÑÐ»Ð¾Ð²Ð¸Ð¹ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ Ð±Ð°Ð½ÐºÐ¾Ð² Ñ Ð½Ð°Ñ Ð½ÐµÑ. ÐÐ¾Ð³Ð´Ð° Ð¿Ð¾ÑÐ²ÑÑÑÑ,
 * Ð¸Ñ Ð¼ÐµÑÑÐ¾ Ð·Ð´ÐµÑÑ Ð¶Ðµ, Ð° Ð½Ðµ Ð² ÑÐ°Ð·Ð¼ÐµÑÐºÐµ ÑÐ¾ÑÐ¼Ñ.
 */

export const FREEDOM_BANK_ID = 3;

/** Freedom Bank, ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð½Ð° 11.10.2026 (ÑÐ¾ ÑÐ»Ð¾Ð² Ð±Ð°Ð½ÐºÐ°). */
export const FREEDOM_CONDITIONS = {
  name: 'Freedom Bank',
  minInitialFeePercent: 10,
  maxInitialFeePercent: 40,
  periods: [60, 72, 84],
};

const toNumber = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string') return null;
  const digits = value.replace(/\s/g, '').replace(',', '.');
  if (digits === '') return null;
  const parsed = Number(digits);
  return Number.isFinite(parsed) ? parsed : null;
};

/** Ð Ð°Ð·ÑÑÐ´Ñ Ð¿ÑÐ¾Ð±ÐµÐ»Ð¾Ð¼. toLocaleString Ð² ÑÐ°Ð·Ð½ÑÑ Ð¾ÐºÑÑÐ¶ÐµÐ½Ð¸ÑÑ ÑÑÐ°Ð²Ð¸Ñ Ð½ÐµÑÐ°Ð·ÑÑÐ²Ð½ÑÐ¹. */
const withSpaces = (value) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

/**
 * ÐÐ¾Ð´ÑÐ¾Ð´Ð¸Ñ Ð»Ð¸ Ð¿ÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ Ð¿Ð¾Ð´ ÑÑÐ»Ð¾Ð²Ð¸Ñ Freedom.
 * null â Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ Ð½ÐµÐ»ÑÐ·Ñ (Ð½ÐµÑ ÑÐµÐ½Ñ Ð¸Ð»Ð¸ Ð²Ð·Ð½Ð¾ÑÐ°), Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼.
 */
export const freedomInitialFeeWarning = (initialFee, carPrice) => {
  const fee = toNumber(initialFee);
  const price = toNumber(carPrice);
  if (fee === null || price === null || price <= 0) return null;

  const percent = (fee / price) * 100;
  const { minInitialFeePercent: min, maxInitialFeePercent: max, name } = FREEDOM_CONDITIONS;

  // ÐÐºÑÑÐ³Ð»ÑÐµÐ¼ ÑÐ°Ðº Ð¶Ðµ, ÐºÐ°Ðº Ð²Ð¸Ð´Ð¸Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ: 9,6% â ÑÑÐ¾ Â«Ð¼ÐµÐ½ÑÑÐµ 10Â».
  const shown = Math.round(percent);
  if (percent < min) {
    const needed = withSpaces(Math.ceil((price * min) / 100));
    return `${name} Ð¾ÑÐºÐ°Ð¶ÐµÑ: Ð²Ð·Ð½Ð¾Ñ ${shown}% â Ð±Ð°Ð½Ðº Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð¾Ñ ${min}% (${needed} â¸).`;
  }
  if (percent > max) {
    return `${name} Ð¾ÑÐºÐ°Ð¶ÐµÑ: Ð²Ð·Ð½Ð¾Ñ ${shown}% â Ð±Ð°Ð½Ðº Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð´Ð¾ ${max}%.`;
  }
  return null;
};

/** ÐÐ¾Ð´ÑÐ¾Ð´Ð¸Ñ Ð»Ð¸ ÑÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð¿Ð¾Ð´ ÑÑÐ»Ð¾Ð²Ð¸Ñ Freedom. */
export const freedomPeriodWarning = (period) => {
  const months = toNumber(period?.value ?? period);
  if (months === null) return null;

  const { periods, name } = FREEDOM_CONDITIONS;
  if (periods.includes(months)) return null;
  return `${name} Ð¾ÑÐºÐ°Ð¶ÐµÑ: ÑÑÐ¾Ðº ${months} Ð¼ÐµÑ â Ð±Ð°Ð½Ðº Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ ${periods.join(', ')}.`;
};
